import React from 'react';
import * as _ from 'lodash';
import classNames from 'classnames';
import Avatar from '../../components/Avatar';
import { __, bytesToSize, dateTimeFrom } from '../../core/utils';
import styles from '../../styles/flyouts/files/FileFlyout.scss';
import Image from '../../components/Image';
import DocumentExtIcon from '../../assets/images/document-ext-30x30.svg';
import { showLightbox } from '../../redux/actions/general/lightbox';

const Details = ({ data, collapsed, onDownload }) => {
  const extension = _.toLower(data.extension || data.ext || '');
  const isImage = _.includes(['jpg', 'jpeg', 'png'], extension);
  const isPdf = extension === 'pdf';
  const previewUrl = data.thumbnail_url || (isImage ? data.stream_url : null);
  const canOpenLightbox =
    (isImage && data.stream_url) || (isPdf && data.download_url);
  const previewTitle = _.filter([data.file_name, extension]).join('.');
  const previewFile = {
    id: data.id,
    attachment_version_id: data.attachment_version_id,
    stream_url: data.stream_url,
    title: previewTitle,
    download_url: data.download_url,
    ext: extension,
    width: data.width,
    height: data.height,
  };
  const previewColor =
    'color' +
    (_.sumBy(extension.split(''), (item) => item.charCodeAt(0)) % 5);

  const openPreview = () => {
    if (canOpenLightbox) {
      showLightbox([previewFile], data.id);
    } else if (onDownload) {
      onDownload(data, true);
    }
  };

  return (
    <div
      className={classNames(
        styles.sectionContent,
        styles.detailsContent,
        collapsed && styles.collapsed,
      )}
    >
      <div className={styles.detailsList}>
        {data.description && (
          <div className={styles.detailRow}>
            <span>{__('files.flyout.description')}</span>
            <strong>{data.description}</strong>
          </div>
        )}
        <div className={styles.detailRow}>
          <span>{__('files.flyout.location')}</span>
          <div className={styles.locations}>
            {_.isEmpty(data.folders) ? (
              <strong>{__('Unallocated')}</strong>
            ) : (
              _.map(data.folders, (folder, folder_index) => (
                <strong key={folder.id}>
                  {folder.color_hex && (
                    <span style={{ backgroundColor: folder.color_hex }} />
                  )}
                  {folder.location}
                  {folder_index < _.size(data.folders) - 1 && ',\u00a0'}
                </strong>
              ))
            )}
          </div>
        </div>
        <div className={styles.detailRow}>
          <span>{__('files.table.uploaded-by')}</span>
          {data.uploaded_by ? (
            <strong className={styles.user}>
              <Avatar
                avatar_url={data.uploaded_by.avatar_url}
                name={data.uploaded_by.name}
                size={24}
              />
              {data.uploaded_by.name}
            </strong>
          ) : (
            <strong>—</strong>
          )}
        </div>
        <div className={styles.detailRow}>
          <span>{__('files.table.uploaded-at')}</span>
          <strong>
            {data.uploaded_at ? dateTimeFrom(data.uploaded_at) : '—'}
          </strong>
        </div>
        <div className={styles.detailRow}>
          <span>{__('files.table.type')}</span>
          <strong>{_.toUpper(extension) || '—'}</strong>
        </div>
        <div className={styles.detailRow}>
          <span>{__('files.table.size')}</span>
          <strong>{data.size ? bytesToSize(data.size) : '—'}</strong>
        </div>
      </div>

      <div className={styles.detailsPreview}>
        <div
          className={classNames(
            styles.filePreviewBox,
            (canOpenLightbox || onDownload) && styles.clickable,
          )}
          onClick={openPreview}
        >
          {previewUrl ? (
            <Image src={previewUrl} />
          ) : (
            <div className={styles.filePreviewIcon}>
              <DocumentExtIcon className={styles[previewColor]} />
              <span>{(extension || 'file').substring(0, 4)}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Details;
